import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../@types/filter";
import { AttendanceLocalUser } from "../../../../@types/attendance-local-user";
import { Paginated } from "../../../../@types/paginated";
import { apisiseci } from "../../../api";
import { useDefaultSearchParams } from "../../../../hooks/useSearchParams";
import { useCurrentOrgao } from "../../../../hooks/useCurrentOrgao";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
  nome?: string;
  cpf?: string;
  unidade?: string;
  orgao?: string;
  orgao_id?: string;
};

export function useAttendanceLocalUserList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const currentOrgaoId = useCurrentOrgao();
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  if (currentOrgaoId && !params.orgao) {
    params = { ...params, orgao_id: currentOrgaoId.toString() };
  }

  return useQuery<Paginated<AttendanceLocalUser>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ["attendance-local", "user", "list", params, currentOrgaoId],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<AttendanceLocalUser>>(
        "/cms/u_usuarios/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }
      );
      return response.data;
    },
  });
}
